/**
 * @desc 取消调拨单
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(aono: string | number, options?: any) {
  return updateResponse(
    http(URL + `/allocationMaster/cancel/${aono}`, {
      method: "POST",

      ...options,
    }),
  );
}
